import { Modal, Form, Button } from 'react-bootstrap'
import { Formik } from 'formik'
import { Lock, Eye, EyeOff, Key } from 'lucide-react'
import { useState } from 'react'
import { ChangePasswordSchema } from '../../../utils/validationSchema'
import api from '../../../config/AxiosInstance'
import * as Common from '../../../utils/Common'
import styles from '../../../pages/Layout/dashboard.module.css'

function ModalChangePassword(props) {
  const [showCurrentPassword, setShowCurrentPassword] = useState(false)
  const [showNewPassword, setShowNewPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)

  async function handleSubmit(values) {
    try {
      const params = {
        old_password: values.CurrentPassword,
        password: values.NewPassword,
        password_confirmation: values.ConfirmPassword
      }
      const res = await api.post('/users/change-password', params)

      if (res.data.success) {
        props.onHide()
        Common.showPopUpSuccessMessage(res.data.message)
      }
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    }
  }

  return (
    <Modal
      {...props}
      centered
      contentClassName={styles.modalContent}
      backdrop="static"
    >
      <Formik
        initialValues={{
          CurrentPassword: '',
          NewPassword: '',
          ConfirmPassword: ''
        }}
        enableReinitialize={true}
        onSubmit={(values) => {
          handleSubmit(values)
        }}
        validateOnChange={true}
        validateOnBlur={true}
        validationSchema={ChangePasswordSchema}
      >
        {({
          handleBlur,
          handleSubmit,
          handleChange,
          values,
          errors,
          touched,
          isValid,
          dirty
        }) => {
          return (
            <Form noValidate onSubmit={handleSubmit}>
              <div className={styles.modalHeader}>
                <div className="d-flex align-items-center gap-3">
                  <div
                    className="rounded bg-light p-3 d-flex align-items-center justify-content-center"
                    style={{ width: '50px', height: '50px' }}
                  >
                    <Key size={24} className="text-primary" />
                  </div>
                  <Modal.Title className={styles.modalTitle}>
                    Change Password
                  </Modal.Title>
                </div>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={props.onHide}
                ></button>
              </div>

              <Modal.Body className={styles.modalBody}>
                <div className="mb-4">
                  <Form.Label className={styles.formLabel}>
                    Current Password
                  </Form.Label>
                  <div className={styles.customInputGroup}>
                    <Lock size={18} className={styles.inputIcon} />
                    <Form.Control
                      type={showCurrentPassword ? 'text' : 'password'}
                      placeholder="Enter current password"
                      name="CurrentPassword"
                      value={values.CurrentPassword}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={styles.customFormControl}
                      isInvalid={
                        touched.CurrentPassword && !!errors.CurrentPassword
                      }
                    />
                    <div
                      className={styles.passwordToggle}
                      onClick={() =>
                        setShowCurrentPassword(!showCurrentPassword)
                      }
                    >
                      {showCurrentPassword ? (
                        <Eye size={18} />
                      ) : (
                        <EyeOff size={18} />
                      )}
                    </div>
                  </div>
                  {touched.CurrentPassword && errors.CurrentPassword && (
                    <div className="text-danger small mt-1 ps-1">
                      {errors.CurrentPassword}
                    </div>
                  )}
                </div>

                <div className="mb-4">
                  <Form.Label className={styles.formLabel}>
                    New Password
                  </Form.Label>
                  <div className={styles.customInputGroup}>
                    <Lock size={18} className={styles.inputIcon} />
                    <Form.Control
                      type={showNewPassword ? 'text' : 'password'}
                      placeholder="Enter new password"
                      name="NewPassword"
                      value={values.NewPassword}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={styles.customFormControl}
                      isInvalid={touched.NewPassword && !!errors.NewPassword}
                    />
                    <div
                      className={styles.passwordToggle}
                      onClick={() => setShowNewPassword(!showNewPassword)}
                    >
                      {showNewPassword ? (
                        <Eye size={18} />
                      ) : (
                        <EyeOff size={18} />
                      )}
                    </div>
                  </div>
                  <div
                    className="text-muted mt-1 ps-1"
                    style={{ fontSize: '11px', lineHeight: '1.4' }}
                  >
                    Password harus 8–20 karakter, mengandung huruf besar, huruf
                    kecil, angka, dan simbol.
                  </div>
                  {touched.NewPassword && errors.NewPassword && (
                    <div className="text-danger small mt-1 ps-1">
                      {errors.NewPassword}
                    </div>
                  )}
                </div>

                <div className="mb-2">
                  <Form.Label className={styles.formLabel}>
                    Confirm New Password
                  </Form.Label>
                  <div className={styles.customInputGroup}>
                    <Lock size={18} className={styles.inputIcon} />
                    <Form.Control
                      type={showConfirmPassword ? 'text' : 'password'}
                      placeholder="Confirm new password"
                      name="ConfirmPassword"
                      value={values.ConfirmPassword}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={styles.customFormControl}
                      isInvalid={
                        touched.ConfirmPassword && !!errors.ConfirmPassword
                      }
                    />
                    <div
                      className={styles.passwordToggle}
                      onClick={() =>
                        setShowConfirmPassword(!showConfirmPassword)
                      }
                    >
                      {showConfirmPassword ? (
                        <Eye size={18} />
                      ) : (
                        <EyeOff size={18} />
                      )}
                    </div>
                  </div>
                  {touched.ConfirmPassword && errors.ConfirmPassword && (
                    <div className="text-danger small mt-1 ps-1">
                      {errors.ConfirmPassword}
                    </div>
                  )}
                </div>
              </Modal.Body>

              <div className={styles.modalFooter}>
                <Button
                  variant="link"
                  onClick={props.onHide}
                  className="text-decoration-none text-muted fw-bold"
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  className={styles.btnUpdate}
                  disabled={!isValid || !dirty}
                >
                  Update Password
                </Button>
              </div>
            </Form>
          )
        }}
      </Formik>
    </Modal>
  )
}

export default ModalChangePassword
